import React, { useEffect, useState, useMemo } from "react";
import Content from "../../../../Components/Dashboard/Content/Content";
import { Eye } from "lucide-react";
import DetailsView from "./DetailsView";
import Loader from "../../../../Utils/Loader";
import "react-datepicker/dist/react-datepicker.css";
import {
  getSubAdminPositions,
  updateTargetAndStoploss,
  getUserName,
  getSubAminUserName,
} from "../../../../Service/admin.service";
import { GetSubadminStrategy } from "../../../../Service/admin.service";

import { fDateTimeSuffix } from "../../../../Utils/Date_formet";
import "react-datepicker/dist/react-datepicker.css";
import { TRADE_EXECUTE } from "../../../../Service/user.service";
import toast from "react-hot-toast";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable1";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { SET_THEME_DETAILS } from "../../../../Service/auth.service";
import { Get_All_Service_for_Client } from "../../../../ReduxStore/Slice/Common/commoSlice";
import { useDispatch } from "react-redux";
import { usePrices } from "../../../../context/PriceContext";

const Tradinghistory = (token) => {
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const gotodashboard = JSON.parse(localStorage.getItem("user_details_goTo"));
  const isgotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const permissions = JSON.parse(localStorage.getItem("permission"));

  const prices = usePrices();
  const dispatch = useDispatch();

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [strategy, setStrategy] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [rowData, setRowData] = useState("");
  const [tradeHistoryData, setTradeHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [editableRows, setEditableRows] = useState({});
  const [tradeUpdates, setTradeUpdates] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [quantityM, setQuantity] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [btnstatus, setBtnstatus] = useState("");
  const [orderType, setOrderType] = useState("");
  const [allStrategy, setAllStrategy] = useState([]);
  const [entryType, setEntryType] = useState("");
  const [SelectedUserName, setSelectedUserName] = useState("ADMIN");
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [AllUsername, setAllUSerName] = useState([]);
  const [tradeViewType, setTradeViewType] = useState("USD");
  const [showLot, setShowLot] = useState(false); // ✅ ADD THIS

  // ✅ Broker detection - Check if trades have Delta Exchange broker
  useEffect(() => {
    const hasTradeBroker2or0 = tradeHistoryData.some(
      (t) => t.userInfo?.broker === "2" || t.userInfo?.broker === "0"
    );
    const hasPermissionBroker2 = permissions?.broker_id?.some(
      (b) => String(b.id) === "2"
    );

    setShowLot(
      permissions?.trade_History_DeltaExchange === 1 ||
      (hasPermissionBroker2 && hasTradeBroker2or0)
    );
  }, [tradeHistoryData, permissions]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newLimit, page) => {
    setLimit(newLimit);
    setCurrentPage(1);
  };

  // Debounce search term
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    getCompanydata();
    GetAllStrategy();
    GetUSerName();
    // getSubAminUserName()
  }, []);

  const GetAllStrategy = async () => {
    try {
      const payload = {
        page: "1",
        limit: "100",
        userid: isgotodashboard
          ? gotodashboard?.user_id
          : user_details?.user_id,
      };

      const response = await GetSubadminStrategy(payload);

      if (response?.status && Array.isArray(response.data)) {
        setAllStrategy(response.data);
      } else {
        setAllStrategy([]);
      }
    } catch (error) {
      console.error("Strategy fetch error:", error);
      setAllStrategy([]);
    }
  };


  const GetUSerName = async () => {
    const subadminId = isgotodashboard
      ? gotodashboard?.user_id
      : user_details?.user_id;

    const res = await getSubAminUserName(
      { userid: subadminId },
      user_details.token
    );

    if (res?.status) {
      setAllUSerName(res.data);
    } else {
      setAllUSerName([]);
    }
  };


  // const GetAllStrategy = async () => {
  //   try {
  //     dispatch(
  //       Get_All_Service_for_Client({
  //         req: {},
  //         token: user_details.token,
  //       })
  //     )
  //       .unwrap()
  //       .then((response) => {
  //         if (response.status) {
  //           setAllStrategy(response.data);
  //         }
  //       });
  //   } catch (error) { }
  // };

  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedSearchTerm]);

  useEffect(() => {
    fetchTradeHistory();
  }, [
    fromDate,
    toDate,
    refresh,
    strategy,
    orderType,
    btnstatus,
    entryType,
    limit,
    currentPage,
    SelectedUserName,
    debouncedSearchTerm,
    tradeViewType,
  ]);

  // ✅ Updated Calculate P&L function with Delta Exchange logic
  const calculatePnL = (trade, livePrice) => {
    const entryPrice = parseFloat(trade.entryPrice);
    const exitPrice = parseFloat(trade.exitPrice);
    const qty = quantityM && quantityM > 0 ? quantityM : trade.quantity;
    const isOpen = trade.orderid?.length === 1;

    if (!entryPrice || qty <= 0) return 0;

    let pnl = 0;

    if (isOpen && livePrice) {
      pnl =
        trade.side === "BUY"
          ? (livePrice - entryPrice) * qty
          : (entryPrice - livePrice) * qty;
    } else if (!isOpen && exitPrice) {
      pnl =
        trade.side === "BUY"
          ? (exitPrice - entryPrice) * qty
          : (entryPrice - exitPrice) * qty;
    }

    // ✅ Delta Exchange P&L adjustment (broker 2 or 0)
    if (showLot) {
      if (trade.symbol === "BTCUSD") {
        pnl = pnl / 1000;
      } else if (trade.symbol === "ETHUSD") {
        pnl = pnl / 100;
      } else if (trade.symbol === "DOGEUSD") {
        pnl = pnl * 100;
      }
    }

    return pnl;
  };

  // ✅ Updated useMemo with showLot dependency
  const { totalPnl, unrealizedPnl } = useMemo(() => {
    let realized = 0;
    let unrealized = 0;

    tradeHistoryData.forEach((trade) => {
      const livePrice = prices?.[trade.symbol]?.spot_price;
      const pnl = calculatePnL(trade, livePrice);

      if (trade.orderid?.length === 2) {
        realized += pnl;
      } else if (trade.orderid?.length === 1) {
        unrealized += pnl;
      }
    });

    return {
      totalPnl: realized,
      unrealizedPnl: unrealized,
    };
  }, [tradeHistoryData, prices, quantityM, showLot]);

  const getCompanydata = async () => {
    try {
      const res = await SET_THEME_DETAILS();
      if (res.status) {
        setBtnstatus(res.data[0]?.pnl_position);
      }
    } catch (error) { }
  };

  const roundSmart = (value) => {
    if (isNaN(value)) return null;
    value = Number(value);

    let digits;
    if (Math.abs(value) >= 1000) {
      digits = 2;
    } else if (Math.abs(value) >= 1) {
      digits = 2;
    } else if (Math.abs(value) >= 0.01) {
      digits = 4;
    } else {
      digits = 6;
    }

    return Number(value.toFixed(digits));
  };

  const fetchTradeHistory = async () => {
    if (btnstatus === "") return;

    setLoading(true);
    try {
      const response = await getSubAdminPositions({
        fromDate,
        toDate,
        strategy,
        orderType,
        entryType,
        UserName: SelectedUserName,
        searchText: debouncedSearchTerm,
        searchSymbol: debouncedSearchTerm, // ✅ ADD THIS for symbol search
        page: currentPage,
        limit,
        currencyType: tradeViewType,
        userid: isgotodashboard
          ? gotodashboard?.user_id
          : user_details?.user_id,
      });

      if (response?.status) {
        setTradeHistoryData(response.data || []);
        setTotalRows(response.pagination?.totalRecords || 0);
      } else {
        setTradeHistoryData([]);
      }
    } catch (err) {
      setTradeHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  const getFieldValue = (row, fieldName) => {
    return tradeUpdates[row._id]?.[fieldName] || row[fieldName] || "";
  };

  const getInputClassName = (row, fieldName) => {
    const errorKey = `${row._id}-${fieldName}`;
    return `form-control form-control-sm ${validationErrors[errorKey] ? "is-invalid" : ""
      }`;
  };

  const handleOnChange = (row, e) => {
    const { name, value } = e.target;
    if (!row._id) return;

    if (value < 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Negative values are not allowed!",
      });
      return;
    }

    setTradeUpdates((prev) => ({
      ...prev,
      [row._id]: { ...prev[row._id], [name]: value },
    }));
  };

  const handleUpdateRow = async (row) => {
    try {
      const target = parseFloat(tradeUpdates[row._id]?.target);
      const stoploss = parseFloat(tradeUpdates[row._id]?.stoploss);
      const entryPrice = parseFloat(row.entryPrice);

      if (!target && !stoploss) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please fill at least Target or Stoploss!",
        });
        return;
      }

      // 🔥 BUY VALIDATION
      if (row.side === "BUY") {
        if (target && target <= entryPrice) {
          Swal.fire({
            icon: "error",
            title: "Invalid Target",
            text: "BUY Target must be greater than Entry Price",
          });
          return;
        }

        if (stoploss && stoploss >= entryPrice) {
          Swal.fire({
            icon: "error",
            title: "Invalid Stoploss",
            text: "BUY Stoploss must be less than Entry Price",
          });
          return;
        }
      }

      // 🔥 SELL VALIDATION
      if (row.side === "SELL") {
        if (target && target >= entryPrice) {
          Swal.fire({
            icon: "error",
            title: "Invalid Target",
            text: "SELL Target must be less than Entry Price",
          });
          return;
        }

        if (stoploss && stoploss <= entryPrice) {
          Swal.fire({
            icon: "error",
            title: "Invalid Stoploss",
            text: "SELL Stoploss must be greater than Entry Price",
          });
          return;
        }
      }

      const payload = {
        tradeId: row._id,
        target,
        stoploss,
      };

      const response = await updateTargetAndStoploss(payload);

      if (response?.status) {
        toast.success("Target & Stoploss updated successfully ✅");
        fetchTradeHistory();
        setEditableRows((prev) => ({ ...prev, [row._id]: false }));
      } else {
        toast.error(response?.message || "Update failed ❌");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong ❌");
    }
  };

  const refresbtn = () => {
    setStrategy("");
    setFromDate("");
    setToDate("");
    setOrderType(0);
    setEntryType("");
    setSearchTerm("");
    setSelectedUserName("ADMIN");
  };

  const handleSquareOff = async (row) => {
    if (row.extstatus !== "ACTIVE") return;

    try {
      const livePrice = prices?.[row.symbol]?.spot_price;

      const data = `symbol:${row.symbol}|ordertype:${row.side === "BUY" ? "SELL" : "BUY"
        }|quantity:100|price:${livePrice}|strategy:${row?.strategy}|key:${row.key
        }|category:${row.category}|signalType:PANEL_SQUAREOFF|tradeid:${row._id
        }`;

      const response = await TRADE_EXECUTE(data);

      if (response.status) {
        toast.success(response.message);
        fetchTradeHistory();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error in square off:", error);
      toast.error("Failed to square off trade");
    }
  };

  const handleChange = (date) => {
    const formatted = format(date, "yyyy-MM-dd");
    return formatted;
  };

  const columns = [
    {
      name: "No",
      selector: (row, index) => (currentPage - 1) * limit + index + 1,
      sortable: false,
      width: "70px",
    },
    {
      name: "Signals Entry Time",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>{row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}</>
      ),
      sortable: true,
      width: "170px",
    },
    {
      name: "Signals Exit Time",
      selector: (row) => row.exitTime,
      cell: (row) => <>{row.exitTime ? fDateTimeSuffix(row.exitTime) : "-"}</>,
      sortable: true,
      width: "170px",
    },
    {
      name: "Symbol",
      selector: (row) => row.symbol,
      sortable: true,
      width: "120px",
    },
    {
      name: "Entry Type",
      selector: (row) => row.side,
      cell: (row) =>
        row?.side === "BUY" ? (
          <span className="badge bg-success" style={{ fontSize: "0.9rem" }}>
            BUY ENTRY
          </span>
        ) : (
          <span className="badge bg-danger" style={{ fontSize: "0.9rem" }}>
            SELL ENTRY
          </span>
        ),
      sortable: true,
      width: "140px",
    },
    {
      name: showLot ? "Lot" : "Quantity",
      selector: (row) => (row.quantity !== null ? quantityM : "-"),
      sortable: true,
      width: "115px",
    },
    {
      name: "Entry Price",
      selector: (row) =>
        row.entryPrice !== null ? parseFloat(row.entryPrice) : "-",
      sortable: true,
      width: "120px",
      cell: (row) =>
        row.entryPrice !== null ? roundSmart(row.entryPrice) : "-",
    },
    {
      name: "Exit / Live Price",
      selector: (row) => {
        const isOpen = row.orderid?.length === 1;
        const price = isOpen ? prices?.[row.symbol]?.spot_price : row.exitPrice;
        return price ?? 0;
      },
      cell: (row) => {
        const isOpen = row.orderid?.length === 1;
        const price = isOpen ? prices?.[row.symbol]?.spot_price : row.exitPrice;

        if (price === undefined || price === null || isNaN(price)) {
          return (
            <div
              className="spinner-border spinner-border-sm text-success"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          );
        }

        return <span>{roundSmart(price)}</span>;
      },
      sortable: true,
      width: "160px",
    },
    {
      name: "P/L",
      selector: (row) => {
        const livePrice = prices?.[row.symbol]?.spot_price;
        return roundSmart(calculatePnL(row, livePrice));
      },
      cell: (row) => {
        const livePrice = prices?.[row.symbol]?.spot_price;
        const pnl = calculatePnL(row, livePrice);

        if (pnl === 0 && !parseFloat(row.entryPrice))
          return <span style={{ color: "gray" }}>-</span>;

        const pnlColor = pnl >= 0 ? "green" : "red";
        return <span style={{ color: pnlColor }}>{roundSmart(pnl)}</span>;
      },
      sortable: true,
      width: "100px",
    },
    {
      name: "Strategy",
      selector: (row) => row.strategy,
      sortable: true,
      width: "140px",
    },
    {
      name: "User Name",
      selector: (row) =>
        row.userInfo?.UserName ? row.userInfo?.UserName : "Admin",
      sortable: true,
      width: "150px",
      cell: (row) => <>{row.userInfo?.UserName}</>,
    },
    {
      name: "platform",
      selector: (row) => (row.platform ? row.platform : "PANEL"),
      sortable: true,
      width: "150px",
      cell: (row) => <>{row.platform}</>,
    },
    // ✅ Target Column (Editable for SUBADMIN's own trades)
    {
      name: "Target",
      selector: (row) => row.target,
      cell: (row) => {
        // ✅ Check if this trade was created by current subadmin
        const currentUserId = isgotodashboard
          ? gotodashboard?.user_id
          : user_details?.user_id;

        const isOwnTrade =
          row.subadmin_id === currentUserId &&
          row.platform === "PANEL";

        return isOwnTrade ? (
          <input
            type="number"
            name="target"
            value={getFieldValue(row, "target") || ""}
            onChange={(e) => handleOnChange(row, e)}
            className={getInputClassName(row, "target")}
            placeholder="Target"
            step="0.01"
            disabled={!editableRows[row._id]}
          />
        ) : (
          <span>{row.target || "-"}</span>
        );
      },
      sortable: true,
      width: "120px",
    },
    // ✅ Stop Loss Column (Editable for SUBADMIN's own trades)
    {
      name: "Stop Loss",
      selector: (row) => row.stoploss,
      cell: (row) => {
        const currentUserId = isgotodashboard
          ? gotodashboard?.user_id
          : user_details?.user_id;

        const isOwnTrade =
          row.subadmin_id === currentUserId &&
          row.platform === "PANEL";

        return isOwnTrade ? (
          <input
            type="number"
            name="stoploss"
            value={getFieldValue(row, "stoploss") || ""}
            onChange={(e) => handleOnChange(row, e)}
            className={getInputClassName(row, "stoploss")}
            placeholder="Stop Loss"
            step="0.01"
            disabled={!editableRows[row._id]}
          />
        ) : (
          <span>{row.stoploss || "-"}</span>
        );
      },
      sortable: true,
      width: "120px",
    },
    // ✅ Action Column (Edit/Confirm/Cancel for SUBADMIN's own trades)
    {
      name: "Action",
      cell: (row) => {
        const currentUserId = isgotodashboard
          ? gotodashboard?.user_id
          : user_details?.user_id;

        const isOwnTrade =
          row.subadmin_id === currentUserId &&
          row.platform === "PANEL";

        if (!isOwnTrade) return null;

        const isEditable = editableRows[row._id];

        return (
          <div className="d-flex gap-2">
            {isEditable ? (
              <>
                <button
                  className="btn btn-success btn-sm"
                  onClick={() => handleUpdateRow(row)}
                >
                  Confirm
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() =>
                    setEditableRows((prev) => ({ ...prev, [row._id]: false }))
                  }
                >
                  Cancel
                </button>
              </>
            ) : (
              <button
                className="btn btn-primary btn-sm"
                onClick={() =>
                  setEditableRows((prev) => ({ ...prev, [row._id]: true }))
                }
                disabled={row.extstatus !== "ACTIVE"}
              >
                {row.extstatus === "ACTIVE" ? "Edit" : "Close"}
              </button>
            )}
          </div>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "160px",
    },
    // ✅ Square Off Column (Only for SUBADMIN's own ACTIVE trades)
    {
      name: "Square Off",
      cell: (row) => {
        const currentUserId = isgotodashboard
          ? gotodashboard?.user_id
          : user_details?.user_id;

        // ✅ Check if this trade belongs to current subadmin
        const isOwnTrade =
          row.subadmin_id === currentUserId &&
          row.platform === "PANEL";

        if (!isOwnTrade) return null;

        return (
          <button
            className="btn btn-outline-danger btn-sm"
            disabled={row.extstatus !== "ACTIVE"}
            onClick={() => {
              Swal.fire({
                title: "Are you sure?",
                text: "You want to square off this trade!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, square off it!",
              }).then((result) => {
                if (result.isConfirmed) {
                  handleSquareOff(row);
                }
              });
            }}
            style={{
              opacity: row.extstatus === "ACTIVE" ? 1 : 0.5,
              cursor: row.extstatus === "ACTIVE" ? "pointer" : "not-allowed",
              fontWeight: "bold",
              borderRadius: "4px",
              padding: "2px 10px",
              minWidth: "90px",
            }}
            title={
              row.extstatus !== "ACTIVE"
                ? "Trade already closed"
                : "Square Off this trade"
            }
          >
            {row.extstatus !== "ACTIVE" ? "Trade Closed" : "Square Off"}
          </button>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "150px",
    },
    {
      name: "Details View",
      cell: (row) => (
        <Eye
          className="mx-2"
          onClick={() => {
            setRowData(row);
            setshowModal(true);
          }}
          style={{ cursor: "pointer" }}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "120px",
    },
  ];

  return (
    <Content
      Page_title="Trade History"
      button_status={false}
      button_status1={true}
    >
      <div className="filter-row row gx-2 gy-2 align-items-end mb-3">
        {/* 🔍 Search with Debounce */}
        <div className="col-lg-2 col-md-4 col-sm-6">
          <label className="form-label mb-1 fw-semibold">Search Symbol</label>
          <input
            type="text"
            placeholder="Search Symbol"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-control"
          />
        </div>

        {/* 👤 Username */}
        <div className="col-lg-2 col-md-3 col-sm-6">
          <label className="form-label mb-1 fw-semibold">User Name</label>
          <select
            value={SelectedUserName}
            onChange={(e) => setSelectedUserName(e.target.value)}
            className="form-control"
          >
            {/* <option value="">All</option> */}
            <option value="ADMIN">Admin</option>

            {AllUsername?.map((data, index) => (
              <option key={index} value={data.UserName}>
                {data.UserName}
              </option>
            ))}
          </select>
        </div>

        {/* 📅 From Date */}
        <div className="col-lg-2 col-md-3 col-sm-6">
          <label className="form-label mb-1 fw-semibold">From Date</label>
          <DatePicker
            selected={fromDate ? new Date(fromDate) : null}
            onChange={(date) => {
              const formattedDate = handleChange(date);
              setFromDate(formattedDate);

              if (toDate && new Date(toDate) < new Date(formattedDate)) {
                setToDate(null);
              }
            }}
            dateFormat="yyyy-MM-dd"
            placeholderText="From"
            className="form-control"
            maxDate={new Date()}
          />
        </div>

        {/* 📅 To Date */}
        <div className="col-lg-2 col-md-3 col-sm-6">
          <label className="form-label mb-1 fw-semibold">To Date</label>
          <DatePicker
            selected={toDate ? new Date(toDate) : null}
            onChange={(date) => setToDate(handleChange(date))}
            dateFormat="yyyy-MM-dd"
            placeholderText="To"
            className="form-control"
            minDate={fromDate ? new Date(fromDate) : null}
            maxDate={new Date()}
            disabled={!fromDate}
          />
        </div>

        {/* 📈 Strategy */}
        <div className="col-lg-1 col-md-3 col-sm-6">
          <label className="form-label mb-1 fw-semibold">Strategy</label>
          <select
            value={strategy}
            onChange={(e) => setStrategy(e.target.value)}
            className="form-control"
          >
            <option value="">All</option>
            {allStrategy?.map((s) => (
              <option key={s._id} value={s.strategy_name}>
                {s.strategy_name}
              </option>
            ))}

          </select>
        </div>

        {/* 🧾 Order Type */}
        <div className="col-lg-1 col-md-3 col-sm-6">
          <label className="form-label mb-1 fw-semibold">Order</label>
          <select
            className="form-control"
            value={orderType}
            onChange={(e) => setOrderType(e.target.value)}
          >
            <option value="">All </option>
            <option value="1">OPEN</option>
            <option value="2">CLOSED</option>
          </select>
        </div>

        {/* 🧭 Entry  */}
        <div className="col-lg-1 col-md-3 col-sm-6">
          <label className="form-label mb-1 fw-semibold">Entry </label>
          <select
            className="form-control"
            value={entryType}
            onChange={(e) => setEntryType(e.target.value)}
          >
            <option value="">All </option>
            <option value="BUY">Buy</option>
            <option value="SELL">Sell</option>
          </select>
        </div>

        {/* 🔢 Quantity/Lot */}
        <div className="col-lg-1 col-md-3 col-sm-6 col-6">
          <label className="form-label mb-1 fw-semibold">
            {showLot ? "Lot" : "Quantity"} {/* ✅ Dynamic label */}
          </label>
          <input
            type="number"
            className="form-control"
            value={quantityM}
            onChange={(e) => {
              const val = e.target.value;
              setQuantity(val === "" ? "" : Number(val));
            }}
          />
        </div>

        {/* 🔁 Refresh Button */}
        <div className="col-lg-1 col-md-2 col-sm-3 d-flex justify-content-end">
          <button
            className="btn btn-sm btn-primary mt-auto w-100"
            onClick={() => {
              setRefresh((prev) => !prev);
              refresbtn();
            }}
          >
            <i className="fa fa-refresh"></i>
          </button>
        </div>

        {/* 🔘 Currency Type Toggle */}
        <div className="col-lg-4 col-md-4 col-sm-12 d-flex gap-2">
          <button
            className={`btn btn-sm ${tradeViewType === "USD" ? "btn-success" : "btn-outline-success"
              }`}
            onClick={() => {
              setTradeViewType("USD");
              setCurrentPage(1);
            }}
          >
            USD Trade
          </button>

          <button
            className={`btn btn-sm ${tradeViewType === "INR" ? "btn-success" : "btn-outline-success"
              }`}
            onClick={() => {
              setTradeViewType("INR");
              setCurrentPage(1);
            }}
          >
            INR Trade
          </button>
        </div>
      </div>

      {/* P&L Summary */}
      {btnstatus === "0" && (
        <div
          className=" alert alert-warning mt-3 d-flex flex-wrap justify-content-between justify-content-md-start align-items-center"
          style={{
            borderTop: "1px solid #ddd",
            paddingTop: "10px",
            marginBottom: "10px",
            borderRadius: "8px",
            padding: "10px 15px",
          }}
        >
          {/* Realized P&L */}
          <div className="realized-text ">
            <h6 className="mb-1 fw-semibold">Realized P&L</h6>
            <span
              className="ms-1"
              style={{
                color: Number(totalPnl) >= 0 ? "green" : "red",
                fontWeight: 600,
                fontSize: "16px",
              }}
            >
              : {Number(roundSmart(totalPnl || 0))}
            </span>
          </div>

          {/* Unrealized P&L */}
          <div className="realized-text ms-3">
            <h6 className="mb-1 fw-semibold fs-6">UnRealized P&L</h6>
            <span
              className="ms-1"
              style={{
                color: Number(unrealizedPnl) >= 0 ? "green" : "red",
                fontWeight: 600,
                fontSize: "16px",
              }}
            >
              :{Number(roundSmart(unrealizedPnl || 0))}
            </span>
          </div>
        </div>
      )}

      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <Table
            columns={columns}
            data={tradeHistoryData}
            waterMark={true}
            totalRows={totalRows}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handlePerRowsChange}
            limit={limit}
          />

          {btnstatus == "1" && (
            <div className="mt-3 d-flex justify-content-end realized-text alert alert-warning">
              <h6>
                Realized P&L:{" "}
                <span style={{ color: totalPnl >= 0 ? "green" : "red" }}>
                  {Number(roundSmart(totalPnl || 0))}
                </span>
              </h6>
              <h6 className="ms-4">
                UnRealized P&L:{" "}
                <span
                  style={{
                    color: Number(unrealizedPnl) >= 0 ? "green" : "red",
                  }}
                >
                  {Number(roundSmart(unrealizedPnl || 0))}
                </span>
              </h6>
            </div>
          )}
        </div>
      )}

      <DetailsView
        showModal={showModal}
        setshowModal={() => setshowModal(false)}
        tradeHistoryData={rowData}
      />
    </Content>
  );
};

export default Tradinghistory;